var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 7,
    fill: "#FFF7E0",
    stroke: "#334456",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.2941C10 11.4748 11.4748 10 13.2941 10C15.1134 10 16.5882 11.4748 16.5882 13.2941C16.5882 15.1134 15.1134 16.5882 13.2941 16.5882C11.4748 16.5882 10 15.1134 10 13.2941ZM15.1765 13.2941C15.1765 12.2545 14.3337 11.4118 13.2941 11.4118C12.2545 11.4118 11.4118 12.2545 11.4118 13.2941C11.4118 14.3337 12.2545 15.1765 13.2941 15.1765C14.3337 15.1765 15.1765 14.3337 15.1765 13.2941Z",
    fill: "#334456"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4118 13.2941C19.4118 11.4748 20.8866 10 22.7059 10C24.5252 10 26 11.4748 26 13.2941C26 15.1134 24.5252 16.5882 22.7059 16.5882C20.8866 16.5882 19.4118 15.1134 19.4118 13.2941ZM24.5882 13.2941C24.5882 12.2545 23.7455 11.4118 22.7059 11.4118C21.6663 11.4118 20.8235 12.2545 20.8235 13.2941C20.8235 14.3337 21.6663 15.1765 22.7059 15.1765C23.7455 15.1765 24.5882 14.3337 24.5882 13.2941Z",
    fill: "#334456"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 22.7059C10 20.8866 11.4748 19.4118 13.2941 19.4118C15.1134 19.4118 16.5882 20.8866 16.5882 22.7059C16.5882 24.5252 15.1134 26 13.2941 26C11.4748 26 10 24.5252 10 22.7059ZM15.1765 22.7059C15.1765 21.6663 14.3337 20.8235 13.2941 20.8235C12.2545 20.8235 11.4118 21.6663 11.4118 22.7059C11.4118 23.7455 12.2545 24.5882 13.2941 24.5882C14.3337 24.5882 15.1765 23.7455 15.1765 22.7059Z",
    fill: "#334456"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4118 22.7059C19.4118 20.8866 20.8866 19.4118 22.7059 19.4118C24.5252 19.4118 26 20.8866 26 22.7059C26 24.5252 24.5252 26 22.7059 26C20.8866 26 19.4118 24.5252 19.4118 22.7059ZM24.5882 22.7059C24.5882 21.6663 23.7455 20.8235 22.7059 20.8235C21.6663 20.8235 20.8235 21.6663 20.8235 22.7059C20.8235 23.7455 21.6663 24.5882 22.7059 24.5882C23.7455 24.5882 24.5882 23.7455 24.5882 22.7059Z",
    fill: "#334456"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardOne);
export default __webpack_public_path__ + "static/media/dashboard_one.5caca3c735bfc679b5a385c3ce52b778.svg";
export { ForwardRef as ReactComponent };